import React, { useEffect, useRef } from 'react';

const BIKHiddenInputs = (props: { showInputs: boolean }) => {
   const { showInputs } = props
   const isFirstRender = useRef(true)

   // >>> SKRYPT BIK CFD - INICJALIZACJA - TYLKO RAZ PRZY PIERWSZYM RENDERZE
   useEffect(() => {
      if (isFirstRender.current && showInputs === true) {
         window.ptadx.ptinitiate(null) //Inicjalizacja skryptu BIK CFD
         isFirstRender.current = false
      }
   }, [])


   if(showInputs === false) {
      return null
   }

   return (
      <>
         <input type="hidden" id="ptsuser_prefs" name="ptsuser_prefs" />   {/* Dodane na potrzeby skryptu BIK CFD NIE ZMIENIAĆ*/}
         <input type="hidden" id="ptsuser_prefs2" name="ptsuser_prefs2" /> {/* Dodane na potrzeby skryptu BIK CFD NIE ZMIENIAĆ*/}
      </>
   )
}

export default BIKHiddenInputs